import { useMemo, useState } from "react";
import useSeo from "@/hooks/useSeo";
import Hero from "@/pages/home/components/Hero";
import HotPosts from "@/pages/home/components/HotPosts";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestFeed from "@/pages/home/components/LatestFeed";
import CommunityStats from "@/pages/home/components/CommunityStats";
import SubmitGuide from "@/pages/home/components/SubmitGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";
import { faqs } from "@/mocks/posts";

export default function Home() {
  const [searchQuery, setSearchQuery] = useState("");

  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "99看料",
        url: "/",
        description: "热点线索分享与评论区互动社区，欢迎留言评论、投稿爆料或反馈意见。",
        potentialAction: {
          "@type": "SearchAction",
          target: "/?keyword={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "99看料",
        url: "/",
        email: "hello@99kanliao.example",
        description: "一个由用户共同书写的热点线索分享与讨论社区。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a,
          },
        })),
      },
    ],
    [],
  );

  useSeo({
    title: "99看料 - 热点线索分享与评论区互动社区",
    description:
      "99看料是面向中文网友的热点线索分享与讨论社区，欢迎留言评论、投稿爆料或反馈意见。每条内容下方都能参与讨论，你的补充与看法也许就是下一条线索。",
    keywords: "99看料,99看料爆料,99看料投稿,99看料评论,99看料留言,99看料互动",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <Hero searchQuery={searchQuery} onSearchChange={setSearchQuery} />
      <HotPosts />
      <CategoryGrid />
      <LatestFeed searchQuery={searchQuery} />
      <CommunityStats />
      <SubmitGuide />
      <FaqSection />
      <BrandSection />
    </>
  );
}